module.exports={
	"add": "Create new project",
	"title": "Title",
	"contest": "Competition"
}
